import { Video } from '../video.types';
import { ProfileAddressDetails } from './address-details';
import { GalleryAsset } from './gallery-asset';
import { AgentGroupingType, AgentType } from './profile-page.types';
import { ProfileTheme } from './profile-theme.types';

export enum EntityProfileTypes {
  RealEstateAgency = 'real-estate-agency',
  RealEstateAgent = 'real-estate-agent',
  MortgageBroker = 'mortgage-broker',
}

export interface AgentProfile {
  agentProfileId: number;
  agentTitle: string;
  agentName: string;
  agentCode: string;
  agentStub: string;
  agentFirstName: string;
  agencyName: string;
  agencyCode: string;
  teamName: string;

  hasEmailAddress: boolean;
  isAgent: boolean;
  isBranded: boolean;
  isBrandedPreview: boolean;
  hasApiAccess: boolean;
  hasListingReport: boolean;
  hasMediaGallery: boolean;
  theme: ProfileTheme;
  hideSponsoredContent: boolean;

  overallStars?: number;
  reviewCount?: number;
  propertyCount?: number;

  about: AgentProfileAbout;

  agentProfileUrl: string;
  agencyProfileUrl: string;
  agencyProfileAgentsUrl: string;
  agentGroupings: AgentGroupingDetails[];

  agentType: AgentType;
  profileTrixelImgUrl: string;
}

export interface AgentProfileAbout {
  summary: string;
  address: string;
  addressDetails: ProfileAddressDetails;
  phone: string;
  mobile: string;
  contactRevealTrixelImgUrl: string;
  contactSubmitTrixelImgUrl: string;

  showAppraisal: boolean;
  isAwardWinner: boolean;

  video: Video;
  galleryAssets: GalleryAsset[];

  facebook: string;
  twitter: string;
  linkedIn: string;
  instagram: string;
  website: string;

  isClaimed: boolean;
  claimEmail: string;
  defaultAlias: string;
  claimId?: string;
}

export interface AgentGroupingDetails {
  profileUrl: string;
  code: string;
  name: string;
  agentGroupingType: AgentGroupingType;
  hasPublicProfile: boolean;
}
